import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { summarizeIssues } from "../../../lib/mfBulkInput/validateRows";
import cls from "./MflistExcelinput.module.css";

export default function BulkInputValidationPanel({
  rows,
  validationCounts,
  showErrorsOnly,
  setShowErrorsOnly,
  onScrollToRow,
}) {
  const issues = summarizeIssues(rows);

  return (
    <aside className={cls.validationPanel}>
      <div style={{ fontWeight: 800, fontSize: "0.82rem", marginBottom: 8 }}>
        검증 결과
      </div>
      <div className={`${cls.statCard} ${cls.statError}`}>
        <div>오류 {validationCounts.errors}건</div>
        {validationCounts.errors > 0 && (
          <button
            type="button"
            className={cls.btnAction}
            style={{ marginTop: 4, fontSize: "0.68rem" }}
            onClick={() => {
              const row = rows.find((r) => r.rowStatus === "error");
              if (row) onScrollToRow?.(row.id);
            }}
          >
            보러가기
          </button>
        )}
      </div>
      <div className={`${cls.statCard} ${cls.statWarning}`}>
        경고 {validationCounts.warnings}건
      </div>
      <div className={`${cls.statCard} ${cls.statNormal}`}>
        정상 {validationCounts.normal}건
      </div>
      <div style={{ fontSize: "0.72rem", color: "#555", marginTop: 8 }}>
        {issues.phoneFormat > 0 && <div>· 전화번호 형식 ({issues.phoneFormat})</div>}
        {issues.requiredMissing > 0 && (
          <div>· 필수값 누락 ({issues.requiredMissing})</div>
        )}
        {issues.duplicate > 0 && <div>· 중복 의심 ({issues.duplicate})</div>}
      </div>
      <FormControlLabel
        sx={{ mt: 1, ml: 0 }}
        control={
          <Switch
            size="small"
            checked={showErrorsOnly}
            onChange={(e) => setShowErrorsOnly(e.target.checked)}
          />
        }
        label={<span style={{ fontSize: "0.78rem" }}>오류만 보기</span>}
      />
    </aside>
  );
}
